import PropertyGateCommand from "./PropertyGateCommand";

const PropertyParkingGateCommand = ({
    parking_gate_command,
    parking_gate_door_command,
    setLoading,
    setSnackbarMsg,
    setSnackbarOpen,
    setPropertyData,
    property_name,
    property_id,
}) => {
    return (<>
        <PropertyGateCommand
            label="Gate"
            fieldName="parking_gate_command"
            commandValue={parking_gate_command}
            updateEndpoint="/update-parking-gate-command"
            executeEndpoint="v1/parking-gate/unlock/"
            setLoading={setLoading}
            setSnackbarMsg={setSnackbarMsg}
            setSnackbarOpen={setSnackbarOpen}
            setPropertyData={setPropertyData}
            property_name={property_name}
            property_id={property_id}
        />

        <PropertyGateCommand
            label="Gate Door"
            fieldName="parking_gate_door_command"
            commandValue={parking_gate_door_command}
            updateEndpoint="/update-parking-gate-door-command"
            executeEndpoint="v1/parking-gate-door/unlock/"
            setLoading={setLoading}
            setSnackbarMsg={setSnackbarMsg}
            setSnackbarOpen={setSnackbarOpen}
            setPropertyData={setPropertyData}
            property_name={property_name}
            property_id={property_id}
        />
    </>);
};

export default PropertyParkingGateCommand;